import React, { useState, useEffect } from 'react';
import {
  Box,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography,
  Button,
  TextField,
  Grid,
  Container
} from '@mui/material';

import { KeyboardArrowLeft } from '@mui/icons-material';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { validateReferringMDForm } from './ValidateReferringMDForm';
// import { useParams } from 'react-router-dom';
import * as caseActions from '../../../actions/caseActions';
import * as patientActions from '../../../actions/patientActions';
import * as loginActions from '../../../actions/loginActions';
import styles from '../dashboardstyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Constants from '../../../config/constants';

const ReferringMD = () => {
  // let { caseId } = useParams();
  // console.log(caseId);
  // redux
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  const [countryCode1, setCountryCode1] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.cardiologistphone !== undefined &&
      st.patient.cardiologistphone !== ''
      ? st.patient.cardiologistphone.split(' ')[0] !== null
        ? st.patient.cardiologistphone.slice(0, st.patient.cardiologistphone.indexOf(' '))
        : '+1'
      : '+1'
  );
  const [countryCode2, setCountryCode2] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.pcpphone !== undefined &&
      st.patient.pcpphone !== ''
      ? st.patient.pcpphone.split(' ')[0] !== null
        ? st.patient.pcpphone.slice(0, st.patient.pcpphone.indexOf(' '))
        : '+1'
      : '+1'
  );
  const [countryCode3, setCountryCode3] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.obgynphone !== undefined &&
      st.patient.obgynphone !== ''
      ? st.patient.obgynphone.split(' ')[0] !== null
        ? st.patient.obgynphone.slice(0, st.patient.obgynphone.indexOf(' '))
        : '+1'
      : '+1'
  );

  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);

  const [showDialog, setShowDialog] = useState(false);

  let navigate = useNavigate();
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        dispatch(caseActions.setViewSummary(true));
      }
    }
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };

  const handleCancel = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    // if (!fromMenu) {
    dispatch(caseActions.setViewSummary(true));
    // }
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const { enqueueSnackbar } = useSnackbar();
  const [saveSubmitted, setSaveSubmitted] = useState(false);

  useEffect(() => {
    // callback from other callers outside this component
    if (st.saveMDInfo) {
      submitCaseMDInfo(formik.values);
      dispatch(caseActions.setSaveMDInfo(false));
    }
    //banner success message
    if (saveSubmitted && !st.isUpdateCaseLoading && st.updatemderror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveSubmitted(false);
    }
  }, [st.saveMDInfo, st.isUpdateCaseLoading, saveSubmitted, st.updatemderror]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cardiologist: st !== undefined ? st.patient.cardiologist : '',
      cardiologistphone:
        st !== undefined &&
        st.patient.cardiologistphone !== undefined &&
        st.patient.cardiologistphone !== ''
          ? st.patient.cardiologistphone
          : '',
      cardiologistemail:
        st !== undefined
          ? st.patient.cardiologistemail !== undefined
            ? st.patient.cardiologistemail.trim()
            : st.patient.cardiologistemail
          : '',
      cardiologistletter: st !== undefined ? st.patient.cardiologistletter : false,
      pcp: st !== undefined ? st.patient.pcp : '',
      pcpphone:
        st !== undefined && st.patient.pcpphone !== undefined && st.patient.pcpphone !== ''
          ? st.patient.pcpphone
          : '',
      pcpemail:
        st !== undefined
          ? st.patient.pcpemail !== undefined
            ? st.patient.pcpemail.trim()
            : st.patient.pcpemail
          : '',
      pcpletter: st !== undefined ? st.patient.pcpletter : false,
      obgyn: st !== undefined ? st.patient.obgyn : '',
      obgynphone:
        st !== undefined && st.patient.obgynphone !== undefined && st.patient.obgynphone !== ''
          ? st.patient.obgynphone
          : '',
      obgynemail:
        st !== undefined
          ? st.patient.obgynemail !== undefined
            ? st.patient.obgynemail.trim()
            : st.patient.obgynemail
          : '',
      obgynletter: st !== undefined ? st.patient.obgynletter : false
    },
    validationSchema: validateReferringMDForm,
    onSubmit: (values) => {
      // alert('Submit UpdateCardiologist API\n' + JSON.stringify(values, null, 2));
      submitCaseMDInfo(values);
      // console.log(values);
      // handleHome();
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
    }
  });

  function formatPhoneToSave(countryCode, phone) {
    return (
      phone.substring(0, countryCode.length) +
      ' ' +
      phone.substring(countryCode.length, phone.length)
    );
  }
  const submitCaseMDInfo = (values) => {
    dispatch(
      patientActions.persistPatientMDInfo(
        values.pcp,
        values.pcpphone,
        values.pcpemail !== undefined ? values.pcpemail.trim() : values.pcpemail,
        values.cardiologist,
        values.cardiologistphone,
        values.cardiologistemail !== undefined
          ? values.cardiologistemail.trim()
          : values.cardiologistemail,
        values.obgyn,
        values.obgynphone,
        values.obgynemail !== undefined ? values.obgynemail.trim() : values.obgynemail,
        values.pcpletter,
        values.cardiologistletter,
        values.obgynletter
      )
    );
    var letter1 = values.pcpletter === 'true' ? 'Primary Care Physician' : '';
    var letter2 =
      values.pcpletter === 'true' && values.cardiologistletter === 'true'
        ? ',Cardiologist'
        : values.cardiologistletter === 'true'
        ? 'Cardiologist'
        : '';
    var letter3 =
      values.pcpletter !== 'true' &&
      values.cardiologistletter !== 'true' &&
      values.obgynletter === 'true'
        ? 'Obstetrician/maternal fetal medicine clinician'
        : values.obgynletter !== 'true'
        ? ''
        : ',Obstetrician/maternal fetal medicine clinician';

    var editCaseMDInfoRequest = {
      caseId: st.caseId,
      pcp: values.pcp,
      pcpPhone: formatPhoneToSave(countryCode2, values.pcpphone),
      pcpEmail: values.pcpemail !== undefined ? values.pcpemail.trim() : values.pcpemail,
      cardiologistName: values.cardiologist,
      cardiologistPhone: formatPhoneToSave(countryCode1, values.cardiologistphone),
      cardiologistEmail:
        values.cardiologistemail !== undefined
          ? values.cardiologistemail.trim()
          : values.cardiologistemail,
      obgyn: values.obgyn,
      obgynPhone: formatPhoneToSave(countryCode3, values.obgynphone),
      obgynEmail: values.obgynemail !== undefined ? values.obgynemail.trim() : values.obgynemail,
      sendLetter: letter1 + letter2 + letter3,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseMDInfo(editCaseMDInfoRequest));
  };

  return (
    <Box>
      <Container>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexDirection: 'row',
            adjustItems: 'center',
            border: 0,
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6">
            Case Info for{' '}
            {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
            {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
            (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'})
          </Typography>
        </Box>
        <Typography style={styles.titleText}>Referring MD information</Typography>

        <Grid container spacing={3}>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                autoFocus
                id="cardiologist"
                label="Primary cardiologist's name"
                name="cardiologist"
                autoComplete="cardiologist"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.cardiologist || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.cardiologist && Boolean(formik.errors.cardiologist)}
                helperText={formik.touched.cardiologist && formik.errors.cardiologist}
              />
              <MuiPhoneNumber
                fullWidth
                size="small"
                defaultCountry={'us'}
                variant="standard"
                inputProps={{ style: { fontSize: 16 } }}
                sx={{ mt: 2 }}
                id="cardiologistphone"
                value={formik.values.cardiologistphone}
                onChange={(value, country) => {
                  console.log(country.dialCode);
                  if (value.includes(' ') && countryCode1 !== value.split(' ')[0]) {
                    setCountryCode1(value.split(' ')[0]);
                    formik.setFieldValue('cardiologistphone', value);
                  } else {
                    setCountryCode1('+' + country.dialCode);
                    formik.setFieldValue('cardiologistphone', value);
                  }
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.cardiologistphone && Boolean(formik.errors.cardiologistphone)}
                helperText={formik.touched.cardiologistphone && formik.errors.cardiologistphone}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="cardiologistemail"
                label="Cardiologist's email"
                name="cardiologistemail"
                autoComplete="cardiologistemail"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.cardiologistemail || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.cardiologistemail && Boolean(formik.errors.cardiologistemail)}
                helperText={formik.touched.cardiologistemail && formik.errors.cardiologistemail}
              />
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Do you want to send your cardiologist your second opinion letter when it is ready?
                </Typography>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="cardiologistletter-group"></FormLabel>
                    <RadioGroup
                      aria-labelledby="cardiologistletter"
                      name="cardiologistletter"
                      value={formik.values.cardiologistletter}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="pcp"
                label="Primary care physician's name"
                name="pcp"
                autoComplete="pcp"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.pcp || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.cardiologist && Boolean(formik.errors.cardiologist)}
                helperText={formik.touched.cardiologist && formik.errors.cardiologist}
              />
              <MuiPhoneNumber
                fullWidth
                size="small"
                defaultCountry={'us'}
                variant="standard"
                inputProps={{ style: { fontSize: 16 } }}
                sx={{ mt: 2 }}
                id="pcpphone"
                value={formik.values.pcpphone}
                onChange={(value, country) => {
                  console.log(country.dialCode);
                  if (value.includes(' ') && countryCode2 !== value.split(' ')[0]) {
                    setCountryCode2(value.split(' ')[0]);
                    formik.setFieldValue('pcpphone', value);
                  } else {
                    setCountryCode2('+' + country.dialCode);
                    formik.setFieldValue('pcpphone', value);
                  }
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.pcpphone && Boolean(formik.errors.pcpphone)}
                helperText={formik.touched.pcpphone && formik.errors.pcpphone}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="pcpemail"
                label="PCP's email"
                name="pcpemail"
                autoComplete="pcpemail"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.pcpemail || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.pcpemail && Boolean(formik.errors.pcpemail)}
                helperText={formik.touched.pcpemail && formik.errors.pcpemail}
              />
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Do you want to send your PCP your second opinion letter when it is ready?
                </Typography>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="pcp-group"></FormLabel>
                    <RadioGroup
                      aria-labelledby="pcpletter"
                      name="pcpletter"
                      value={formik.values.pcpletter}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Grid>
          {st.caseType.includes('fetus') && (
            <Grid
              container
              item
              xs={12}
              md={6}
              lg={6}
              direction="column"
              sx={styles.blockContainerStyle}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 0,
                  mt: 0,
                  width: 400
                }}>
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="obgyn"
                  label="Obstetrician/maternal fetal medicine clinician's name"
                  name="obgyn"
                  autoComplete="obgyn"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  autoFocus
                  value={formik.values.obgyn || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.obgyn && Boolean(formik.errors.obgyn)}
                  helperText={formik.touched.obgyn && formik.errors.obgyn}
                />
                <MuiPhoneNumber
                  fullWidth
                  size="small"
                  defaultCountry={'us'}
                  variant="standard"
                  inputProps={{ style: { fontSize: 16 } }}
                  sx={{ mt: 2 }}
                  id="obgynphone"
                  value={formik.values.obgynphone}
                  onChange={(value, country) => {
                    console.log(country.dialCode);
                    if (value.includes(' ') && countryCode3 !== value.split(' ')[0]) {
                      setCountryCode3(value.split(' ')[0]);
                      formik.setFieldValue('obgynphone', value);
                    } else {
                      setCountryCode3('+' + country.dialCode);
                      formik.setFieldValue('obgynphone', value);
                    }
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.obgynphone && Boolean(formik.errors.obgynphone)}
                  helperText={formik.touched.obgynphone && formik.errors.obgynphone}
                />
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  id="obgynemail"
                  label="Obstetrician/maternal fetal medicine clinician's email"
                  name="obgynemail"
                  autoComplete="obgynemail"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.obgynemail || ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.obgynemail && Boolean(formik.errors.obgynemail)}
                  helperText={formik.touched.obgynemail && formik.errors.obgynemail}
                />
              </Box>
            </Grid>
          )}
          {st.caseType.includes('fetus') && (
            <Grid
              container
              item
              xs={12}
              md={6}
              lg={6}
              direction="column"
              sx={styles.blockContainerStyle}>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Do you want to send your obstetrician/maternal fetal medicine clinician your
                  second opinion letter when it is ready?
                </Typography>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="obgynletter-group"></FormLabel>
                    <RadioGroup
                      aria-labelledby="obgynletter"
                      name="obgynletter"
                      value={formik.values.obgynletter}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Grid>
          )}
          <Grid
            container
            item
            xs={12}
            md={12}
            lg={12}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box>
              <Typography style={styles.errorText}>{st.updatemderror}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 2,
                border: 0,
                width: 600
              }}>
              <Dialog
                open={showDialog}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You are about to leave the form and the form contain unsaved data. Do you want
                    to save?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancel}>No</Button>
                  <Button
                    onClick={() => {
                      // reset flag
                      dispatch(caseActions.setDataUpdated(false));
                      // reset fromMenu
                      // setFromMenu(false);
                      setShowDialog(false);
                      submitCaseMDInfo(formik.values);
                      dispatch(caseActions.setViewSummary(true));
                    }}
                    autoFocus>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleHome}>
                <KeyboardArrowLeft />
                Home
              </Button>
              <Button size="large" variant="contained" onClick={formik.handleSubmit} sx={{ mb: 5 }}>
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ReferringMD;
